import PackageSlider from "./PackageSlider";

export * from "./PackageSlider";

export default PackageSlider;
